import { render, staticRenderFns } from "./GatClientSelect.vue?vue&type=template&id=29058154&scoped=true&"
import script from "./GatClientSelect.vue?vue&type=script&lang=js&"
export * from "./GatClientSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29058154",
  null
  
)

export default component.exports